/* global PhotoSwipeLightbox */

const PSWP_LIGHTBOX_SRC = 'https://unpkg.com/photoswipe@5.2.2/dist/photoswipe-lightbox.esm.js'
const ARROW_PREV = `<svg aria-hidden="true" class="pswp__icn" focusable="false" role="presentation" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`
const ARROW_NEXT = `<svg aria-hidden="true" class="pswp__icn" focusable="false" role="presentation" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>`
const ZOOM = `<svg aria-hidden="true" class="pswp__icn" focusable="false" role="presentation" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"></path><path fill-rule="evenodd" class="vertical-line" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"></path></svg>`
const CLOSE = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="pswp__icn" focusable="false" role="presentation" fill="none" viewBox="0 0 18 17"><path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path></svg>`

let LightboxCtor = null

async function loadLightbox() {
  if (LightboxCtor) return LightboxCtor
  const mod = await import(PSWP_LIGHTBOX_SRC)
  LightboxCtor = mod?.default
  return LightboxCtor
}

function getCurrentMediaData(instance) {
  const pswp = instance?.pswp
  const slideData = pswp?.currSlide?.data || pswp?._initialItemData || {}
  const element = slideData.element
  const link = element?.matches?.('a') ? element : element?.querySelector?.('a')
  const mediaId =
    link?.dataset.mediaId ||
    element?.closest?.('[media-id]')?.getAttribute('media-id') ||
    link?.querySelector?.('[data-media-id]')?.dataset.mediaId ||
    link?.querySelector?.('img')?.id ||
    element?.querySelector?.('img')?.id
  const mediaIndex = Number.parseInt(link?.dataset.pswpIndex ?? slideData.index ?? pswp?.currIndex, 10)

  return {
    mediaId,
    mediaIndex: Number.isInteger(mediaIndex) ? mediaIndex : null,
  }
}

function syncProductGallery(instance) {
  const { mediaId, mediaIndex } = getCurrentMediaData(instance)
  const mediaGalleryEl = document.querySelector('[data-id="product-media-gallery"]')

  mediaGalleryEl?.selectMediaById?.(mediaId, {
    mediaIndex,
    emitChange: false,
  })
}

function initLightbox(Lightbox, gallery, children, opts = {}) {
  if (!Lightbox || !document.querySelector(gallery)) return null
  const instance = new Lightbox({
    arrowPrevSVG: ARROW_PREV,
    arrowNextSVG: ARROW_NEXT,
    closeSVG: CLOSE,
    zoomSVG: ZOOM,
    gallery,
    children,
    showHideAnimationType: 'zoom',
    showAnimationDuration: 250,
    hideAnimationDuration: 125,
    ...opts,
  })
  let invoker = null
  let inertedElements = []
  let previousOverflow = ''
  if (opts.isMobile) {
    const galleryElement = document.querySelector(gallery)
    galleryElement.addEventListener('click', () => {
      const regionalMediaEnabled = galleryElement.querySelector('hh-product-thumbnails')?.getAttribute('international-media') === 'true'
      instance.options.children = [...galleryElement.querySelectorAll(children)]
        .filter(link => regionalMediaEnabled || !link.closest('[data-regional-media]'))
        .sort((a, b) => Number(a.dataset.pswpIndex) - Number(b.dataset.pswpIndex))
    }, { capture: true })
  }
  instance.init()
  instance.on('beforeOpen', () => {
    invoker = document.activeElement
    document
      .querySelector(gallery)
      ?.querySelectorAll('a[data-pswp-width]')
      .forEach(el => {
        el.setAttribute('aria-expanded', 'true')
      })
  })
  instance.on('afterInit', () => {
    const dialog = instance.pswp?.element
    if (!dialog) return

    dialog.setAttribute('role', 'dialog')
    dialog.setAttribute('aria-modal', 'true')
    dialog.setAttribute('aria-label', 'Product image gallery')
    inertedElements = [...document.body.children].filter(element => {
      return element !== dialog && !element.contains(dialog) && !element.inert
    })
    inertedElements.forEach(element => { element.inert = true })
    previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
  })
  instance.on('close', () => {
    syncProductGallery(instance)

    document
      .querySelector(gallery)
      ?.querySelectorAll('a[data-pswp-width]')
      .forEach(el => {
        el.setAttribute('aria-expanded', 'false')
      })

    inertedElements.forEach(element => { element.inert = false })
    inertedElements = []
    document.body.style.overflow = previousOverflow
    invoker?.focus()
  })
  return instance
}

async function initPhotoSwipe() {
  console.debug('PDP: Initializing PhotoSwipe')
  loadLightbox().then(Lightbox => {
    if (!Lightbox) return
    const desktop = initLightbox(Lightbox, '#zoom-gallery', '.main-item:not([aria-hidden="true"]) a', {
      pswpModule: () => import('./lib-photoswipe.js'),
    })
    const mobile = initLightbox(Lightbox, '#zoom-gallery-mobile', '.gallery-mobile .swiper-slide .product-media__image__container a', {
      isMobile: true,
      pswpModule: () => import('./lib-photoswipe.js'),
    })

    document.addEventListener('variant:media-change', () => {
      setTimeout(function () {
        desktop?.init?.()
      }, 100)
      setTimeout(function () {
        mobile?.init?.()
      }, 100)
    })
  })
}

function initProductMediaModal() {
  const mediaGalleryEl = document.querySelector('[data-id="product-media-gallery"]')

  if (mediaGalleryEl && mediaGalleryEl.getAttribute('data-media-status') === 'loading') {
    console.debug('PDP: PhotoSwipe - Waiting for media to load')
    document.addEventListener('pdp:media-loaded', (e) => {
      console.debug('PDP: PhotoSwipe - Media loaded', e.detail)
      initPhotoSwipe()
    }, { once: true })
  } else {
    initPhotoSwipe()
  }
}

document.addEventListener('DOMContentLoaded', initProductMediaModal)
